import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Bulma from 'bulma'
import BulmaSwicher from 'bulma-switch'
import CheckRadio from 'bulma-checkradio'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { far } from '@fortawesome/free-regular-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {createPinia} from "pinia";

library.add(fas, far, fab)

const Vue = createApp(App)
const pinia = createPinia()

Vue.use(store)
Vue.use(router)
Vue.use(pinia)
Vue.use(Bulma)
Vue.use(BulmaSwicher)
Vue.use(CheckRadio)
Vue.component('font-awesome-icon', FontAwesomeIcon)

fetch(process.env.BASE_URL + "config.json")
    .then((response) => response.json())
    .then((config) => {
        // either use window.config
        window.config = config
        // or use [Vue Global Config][1]
        Vue.config.globalProperties.$config = config
        Vue.mount('#app')
    })
